import { gql } from '@apollo/client';

import { Assignment } from '../../types';
import { assignmentFragment } from '../fragments';

export interface ToggleAssignmentMutationVariables {
  courseId: string;
  assignmentId: string;
  action: 'disable' | 'enable';
}

export interface ToggleAssignmentMutationResult {
  assignment: Assignment;
}

export const toggleAssignmentMutation = gql`
  mutation ToggleAssignmentMutation($courseId: String!, $assignmentId: String!, $action: String!) {
    assignment(courseId: $courseId, assignmentId: $assignmentId, action: $action, input: {})
      @rest(type: "Assignment", path: "courses/{args.courseId}/assignments/{args.assignmentId}/{args.action}", method: "PUT") {
      ...Assignment
    }
  }
  ${assignmentFragment}
`;
